<template>
  <div
    class="activities-container"
    :class="showList ? 'list' : ''"
    v-if="showResults && ((!showList && galleryItems?.length) || showList)"
  >
    <div
      class="activities-filter"
      v-if="showList"
      :class="isDatePickerOpen ? 'open' : ''"
    >
      <div class="filter-group">
        <div class="item">
          <el-dropdown
            trigger="click"
            ref="locationDropdown"
            popper-class="filter-dropdown location"
            :teleported="false"
          >
            <div class="selector-container">
              <ElButton type="primary square">
                <Icons name="16px/location" />
                <div class="button-text">
                  <span>
                    {{
                      filterActivities.filterField.locations.value?.length
                        ? filterActivities.filterField.locations.value.join(
                            ', '
                          )
                        : $t('select_destinations')
                    }}
                  </span>
                </div>
                <Icons name="16px/chevron_down" />
              </ElButton>
            </div>
            <template #dropdown>
              <UtilsFilterLocations
                @selectedLocation="
                  filterActivities.filterField.locations.value = $event
                "
                :show-actions="true"
                @filter="filter(), $refs.locationDropdown.handleClose()"
              />
            </template>
          </el-dropdown>
        </div>
        <div class="item">
          <ElDatePicker
            class="landing-date-range square"
            :start-placeholder="$t('select_dates')"
            v-model="filterActivities.where.dateFilter"
            type="daterange"
            :disabled-date="isDisableDates"
            format="DD/MM/YYYY"
            popper-class="custom-daterangepicker"
            :editable="false"
            :clearable="true"
            clear-icon="Close"
            @calendar-change="rangeDateChange($event, 'date')"
            @visible-change="isDatePickerOpen = $event"
          />
        </div>
        <div class="item">
          <el-dropdown
            trigger="click"
            popper-class="filter-dropdown"
            :teleported="false"
            :hide-on-click="false"
            ref="difficultyLevelDropdown"
          >
            <div class="selector-container">
              <ElButton type="primary square">
                <Icons name="20px/speedometer_light_1" />
                <div class="button-text">
                  <span>
                    {{
                      filterActivities.where.difficultyLevelLabel
                        ? $t(filterActivities.where.difficultyLevelLabel)
                        : $t('difficulty')
                    }}
                  </span>
                </div>
                <Icons name="16px/chevron_down" />
              </ElButton>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="item in difficultyLevelsArray"
                  :key="item.value"
                >
                  <ElCheckbox
                    class="landing-checkbox-rounded"
                    v-model="item.selected"
                    @change="
                      ;(filterActivities.where.difficulty_level.value =
                        item.value),
                        (filterActivities.where.difficultyLevelLabel =
                          item.text)
                    "
                  />
                  <span class="body2">
                    {{ $t(item.text) }}
                  </span></el-dropdown-item
                >
                <el-dropdown-item class="actions">
                  <ElButton
                    type="link dark"
                    @click="
                      ;(filterActivities.where.difficulty_level.value = ''),
                        (filterActivities.where.difficultyLevelLabel = ''),
                        filter(),
                        $refs.difficultyLevelDropdown.handleClose()
                    "
                  >
                    {{ $t('clear') }}
                  </ElButton>
                  <ElButton
                    type="primary dark"
                    @click="
                      filter(), $refs.difficultyLevelDropdown.handleClose()
                    "
                  >
                    {{ $t('apply') }}
                  </ElButton>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <ElButton
        type="primary"
        class="button-filter"
        @click="openFilterDrawer()"
      >
        {{ width >= 1100 ? $t('filters') : $t('filter_and_sort') }}
        <Icons name="16px/filtering" />
      </ElButton>
    </div>
    <div class="activities-title">
      <div class="title-text">
        <span class="heading3" v-if="route.name === 'activities-id'">{{
          $t('similar_activities')
        }}</span>
        <span class="heading3" v-else>{{ $t('signature_activities') }}</span>
      </div>
      <div class="title-action" v-if="!showList">
        <ElButton type="link dark arrow" @click="$emit('allActivities')"
          >{{ $t('all') }}<Icons name="16px/arrow_right"
        /></ElButton>
      </div>
      <div class="title-filter" v-else-if="showList">
        <ElButton
          :type="width >= 1100 ? 'primary dark' : 'icon dark'"
          @click="fullscreeMap()"
        >
          <span v-if="width >= 1100">{{ $t('map_view') }}</span>
          <Icons name="16px/map_white" />
        </ElButton>
        <ElSelect
          v-if="width >= 1100"
          v-model="sortBy"
          :autocomplete="true"
          class="!w-full landing-select no-background"
          :placeholder="$t('sort_by')"
          @change="filter()"
          :fallback-placements="['top', 'bottom']"
          :popper-options="getSelectPopperOptions()"
          popper-class="custom-selector"
        >
          <el-option
            v-for="item in sortByOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </ElSelect>
      </div>
    </div>
    <div class="activities-gallery">
      <div class="gallery-container">
        <carousel
          v-if="!showList"
          :items-to-scroll="width <= 1100 ? 1 : 1"
          :breakpoints="{
            0: {
              itemsToShow: 1.4,
              snapAlign: 'start'
            },
            700: {
              itemsToShow: 2.4,
              snapAlign: 'start'
            },
            1200: {
              itemsToShow: 3,
              snapAlign: 'start'
            },
            1450: {
              itemsToShow: 4,
              snapAlign: 'start'
            },
            1600: {
              itemsToShow: 4,
              snapAlign: 'start'
            },
            1900: {
              itemsToShow: 4.5,
              snapAlign: 'start'
            }
          }"
        >
          <slide
            v-for="item in galleryItems"
            :key="item.uuid"
            @click="router.push(`/activities/${item.uuid}`)"
          >
            <div class="gallery">
              <div
                class="image"
                :class="item.cover || item.image ? 'with-image' : ''"
              >
                <div
                  class="exclusive"
                  v-if="getAuthUser()?.value?.uuid && !item.user_can_purchase"
                >
                  <span class="small">
                    {{ $t('exclusive') }}
                  </span>
                </div>
                <video
                  v-if="item.cover"
                  :src="item.cover"
                  autoplay
                  muted
                  loop
                />
                <img v-else-if="item.image" :src="item.image" loading="lazy" />
                <img
                  v-else
                  src="/logos/PALC_Marque_Gold.svg"
                  alt="logo"
                  class="logo-img"
                />
              </div>
              <div class="gallery-title">
                <span class="heading6">{{ item.title }}</span>
              </div>
              <div class="gallery-location">
                <span class="caption" v-if="item.location">{{
                  item.location
                }}</span
                ><span class="caption" v-if="item.date">{{ item.date }}</span>
              </div>
            </div>
          </slide>

          <template #addons>
            <navigation />
            <pagination />
          </template>
        </carousel>
        <ElRow
          v-infinite-scroll="loadMoreItems"
          :gutter="20"
          v-else-if="showList && galleryItems?.length"
        >
          <ElCol
            :span="24"
            :sm="12"
            :md="12"
            :lg="width <= 1600 ? 8 : 6"
            :xl="6"
            class="gallery"
            v-for="item in galleryItems"
            :key="item.uuid"
            @click="router.push(`/activities/${item.uuid}`)"
          >
            <div
              class="image"
              :class="item.cover || item.image ? 'with-image' : ''"
            >
              <div
                class="exclusive"
                v-if="getAuthUser()?.value?.uuid && !item.user_can_purchase"
              >
                <span class="small">
                  {{ $t('exclusive') }}
                </span>
              </div>
              <video v-if="item.cover" :src="item.cover" autoplay muted loop />
              <img v-else-if="item.image" :src="item.image" loading="lazy" />
              <img
                v-else
                src="/logos/PALC_Marque_Gold.svg"
                alt="logo"
                class="logo-img"
              />
            </div>
            <div class="gallery-title">
              <span class="heading6">{{ item.title }}</span>
            </div>
            <div class="gallery-location" v-if="!showReservation">
              <span class="caption" v-if="item.location">{{
                item.location
              }}</span
              ><span class="caption" v-if="item.date">{{ item.date }}</span>
            </div>
            <div class="gallery-actions" v-if="showReservation">
              <ElButton
                type="secondary dark"
                @click.stop.prevent="$emit('addToItinerary', item)"
              >
                {{ $t('add_to_itinerary') }}
                <Icons
                  name="16px/plus"
                  class="ml-2"
                  style="margin-right: -8px"
                />
              </ElButton>
            </div>
          </ElCol>
        </ElRow>
        <div
          class="content-empty"
          v-if="showList && galleryItems?.length === 0"
        >
          <div class="empty-title">
            <span class="heading3">
              {{ $t('we_couldn_t_find_any_exact_matches_for_that_search') }}.
              {{ $t('try') }}
              <span
                class="heading3 underline cursor-pointer"
                @click="filterDrawer = true"
              >
                {{ $t('changing_or_removing_some_of_your_filters') }} </span
              >,&nbsp;{{ $t('or') }}
              <span
                class="heading3 underline cursor-pointer"
                @click="goToDonatella()"
                >{{ $t('speak_to_donatella') }}</span
              >
              {{ $t('for_inspiration') }}
            </span>
          </div>
          <div class="empty-icon">
            <Icons name="24px/heart_filled" />
          </div>
        </div>
      </div>
    </div>
    <UtilsListMap v-if="showList" :items="galleryItems" ref="activityMap" />
    <UtilsFooter v-if="showList" />
    <el-drawer v-model="filterDrawer" direction="rtl" class="left-drawer">
      <template #header>
        <span class="heading3">{{ $t('filter_activities') }}</span>
      </template>
      <template #default>
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" v-if="width < 1100">
            <template #title>
              <span class="body2-strong">
                {{ $t('sort_by') }}
              </span>
              <Icons
                name="16px/minus"
                class="filter-icon"
                v-if="activeNames.includes('1')"
              />
              <Icons name="16px/plus" class="filter-icon" v-else />
            </template>
            <ElSelect
              v-model="sortBy"
              :autocomplete="true"
              class="!w-full landing-select"
              :placeholder="$t('sort_by')"
              @change="$emit('input')"
              :fallback-placements="['top', 'bottom']"
              :popper-options="getSelectPopperOptions()"
              popper-class="custom-selector"
            >
              <el-option
                v-for="item in sortByOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </ElSelect>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template #title>
              <span class="body2-strong">
                {{ $t('duration') }}
              </span>
              <Icons
                name="16px/minus"
                class="filter-icon"
                v-if="activeNames.includes('2')"
              />
              <Icons name="16px/plus" class="filter-icon" v-else />
            </template>
            <div class="item-list">
              <div
                v-for="item in durationsOptions ?? []"
                :key="item.value"
                class="item"
              >
                <ElCheckbox
                  class="landing-checkbox-rounded"
                  :model-value="isDurationSelected(item)"
                  @change="selectedDuration(item)"
                />
                <span class="body2">
                  {{ item.label }}
                </span>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template #title>
              <span class="body2-strong">
                {{ $t('kids_friendly') }}
              </span>
              <Icons
                name="16px/minus"
                class="filter-icon"
                v-if="activeNames.includes('3')"
              />
              <Icons name="16px/plus" class="filter-icon" v-else />
            </template>
            <ElSwitch
              class="landing-switch"
              :model-value="filterActivities.where.kids_friendly.value === true"
              @change="filterActivities.where.kids_friendly.value = $event"
            />
          </el-collapse-item>
          <el-collapse-item name="4">
            <template #title>
              <span class="body2-strong">
                {{ $t('specialties') }}
              </span>
              <Icons
                name="16px/minus"
                class="filter-icon"
                v-if="activeNames.includes('4')"
              />
              <Icons name="16px/plus" class="filter-icon" v-else />
            </template>
            <div class="item-list">
              <div
                v-for="item in specialties ?? []"
                :key="item.value"
                class="item"
              >
                <ElCheckbox
                  class="landing-checkbox-rounded"
                  :model-value="isSpecialtySelected(item)"
                  @change="selectedSpecialty(item)"
                />
                <span class="body2">
                  {{ item.label }}
                </span>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="5">
            <template #title>
              <span class="body2-strong">
                {{ $t('langs') }}
              </span>
              <Icons
                name="16px/minus"
                class="filter-icon"
                v-if="activeNames.includes('5')"
              />
              <Icons name="16px/plus" class="filter-icon" v-else />
            </template>
            <div class="item-list">
              <div
                v-for="item in languages ?? []"
                :key="item.iso_code"
                class="item"
              >
                <ElCheckbox
                  class="landing-checkbox-rounded"
                  :model-value="isLanguageSelected(item)"
                  @change="selectedLanguage(item)"
                />
                <span class="body2">
                  {{ item.label }}
                </span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </template>
      <template #footer>
        <ElButton type="link dark" @click="resetFilter()" :loading="loading">
          {{ $t('clear') }}
        </ElButton>
        <ElButton type="primary dark" @click="filter()" :loading="loading">
          <span>{{ $t('show_activities') }}</span>
        </ElButton>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/dist/locale/es'
import 'moment/dist/locale/en-gb'
import 'moment/dist/locale/fr'
import 'moment/dist/locale/de'
import 'moment/dist/locale/sv'
import 'moment/dist/locale/ar'
import { ElLoading, ElMessageBox } from 'element-plus'
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'
import { useI18n } from 'vue-i18n'
import { cloneDeep } from 'lodash'
import { difficultyLevels } from '~/models/difficulty-levels'

export default defineComponent({
  name: 'Activities',
  props: {
    showList: {
      type: Boolean,
      required: false,
      default: false
    },
    showReservation: {
      type: Boolean,
      required: false,
      default: false
    },
    activity: {
      type: Object,
      default: () => {}
    },
    showLoading: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      activities: null,
      loadingDialog: null,
      loading: false,
      filterExists: false,
      filterDrawer: false,
      filterActivities: {
        where: {
          uuid: {
            column: 'UUID',
            operator: 'NEQ',
            value: ''
          },
          kids_friendly: {
            column: 'KIDS_FRIENDLY',
            operator: 'EQ',
            value: ''
          },
          date: {
            column: 'DATE',
            operator: 'BETWEEN',
            value: {
              from: null,
              to: null
            }
          },
          dateFilter: '',
          difficulty_level: {
            column: 'DIFFICULTY_LEVEL',
            operator: 'EQ',
            value: ''
          },
          difficultyLevelLabel: '',
          duration: {
            column: 'DURATION',
            operator: '',
            value: 0
          }
        },
        filterField: {
          name: {
            value: ''
          },
          location: {
            value: ''
          },
          locations: {
            value: ''
          },
          orderForList: {
            value: ''
          },
          languages: {
            value: []
          },
          specialties: {
            value: []
          }
        }
      },
      activeNames: ['1', '2', '3', '4', '5'],
      markerSelected: null,
      showResults: false,
      totalPages: null,
      currentPage: null,
      page: 1,
      sortBy: 'NAME',
      isDatePickerOpen: false
    }
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation
  },
  setup() {
    const { width, height } = useBreakpoints()
    const { t } = useI18n()
    const { $sentry } = useNuxtApp()
    const router = useRouter()
    const route = useRoute()
    const config = useRuntimeConfig()

    const initialVariables = []

    let objectToReturn = {
      width,
      height,
      t,
      router,
      route,
      $sentry,
      config,
      languages: getLanguagesLanding(),
      specialties: getSpecialties()
    }
    for (const variable of initialVariables) {
      objectToReturn = Object.assign(objectToReturn, variable)
    }

    return objectToReturn
  },
  computed: {
    language() {
      return getAuthUser()?.value?.language
        ? getAuthUser()?.value?.language
        : this.$i18n.locale
    },
    galleryItems() {
      if (this.activities?.getAllActivities?.data?.length) {
        return this.activities.getAllActivities.data.map((activity) => {
          return {
            uuid: activity.uuid,
            type: 'activity',
            title:
              this.$i18n.locale === 'es'
                ? activity.name_es
                : this.$i18n.locale === 'en'
                ? activity.name_en
                : this.$i18n.locale === 'fr'
                ? activity.name_fr
                : this.$i18n.locale === 'de'
                ? activity.name_de
                : this.$i18n.locale === 'sv'
                ? activity.name_sv
                : this.$i18n.locale === 'ar'
                ? activity.name_ar
                : activity.name,
            cover: activity.coverVideo?.url ?? null,
            image: activity.mainImage?.url ?? null,
            location: activity.location?.name ?? null,
            date: this.getActivityDate(activity),
            user_can_purchase: activity.user_can_purchase,
            price: activity.price,
            currency: getAuthUser()?.value?.currency ?? 'usd',
            coordinates: activity.location?.address
              ? {
                  lat: activity.location.address.latitude,
                  lng: activity.location.address.longitude
                }
              : null
          }
        })
      }
      return []
    },
    sortByOptions() {
      return [
        {
          value: 'NAME',
          label: this.$t('name')
        },
        {
          value: 'DURATION',
          label: this.$t('duration')
        }
      ]
    },
    difficultyLevelsArray() {
      return difficultyLevels['activities'].map((i) => {
        return {
          ...i,
          selected:
            this.filterActivities.where.difficulty_level.value === i.value
        }
      })
    },
    durationsOptions() {
      return [
        {
          value: 30,
          operator: 'LTE',
          label: this.$t('up_to_30_minutes')
        },
        {
          value: 60,
          operator: 'EQ',
          label: this.$t('1_hour')
        },
        {
          value: {
            from: 60,
            to: 120
          },
          operator: 'BETWEEN',
          label: this.$t('1_to_2_hours')
        },
        {
          value: 120,
          operator: 'GTE',
          label: this.$t('more_than_2_hours')
        }
      ]
    }
  },
  mounted() {
    this.getActivities()
  },
  methods: {
    async getActivities(refetch = false) {
      try {
        if (this.showLoading) {
          this.loadingDialog = ElLoading.service({
            fullscreen: true,
            background: '#F7F7F7',
            svg: useLoaderSvg(),
            svgViewBox: useLoaderSvgViewBox()
          })
        }
        if (this.route.name === 'activities-id') {
          this.filterActivities.filterField.location.value =
            this.activity?.location?.name
          this.filterActivities.where.uuid.value = this.activity?.uuid
        }
        if (this.showList && this.sortBy === 'NAME') {
          this.filterActivities.filterField.orderForList.value = true
        } else {
          this.filterActivities.filterField.orderForList.value = false
        }
        const filterActivities = cloneDeep(this.filterActivities)
        delete filterActivities.where.dateFilter
        delete filterActivities.where.difficultyLevelLabel
        if (!this.filterActivities.where.duration.value) {
          delete filterActivities.where.duration
        }
        const activities = await apolloActivities(
          {
            sortBy: this.showList
              ? this.sortBy !== 'NAME'
                ? this.sortBy
                : ''
              : 'CREATED_AT',
            sortDesc: this.showList ? '' : false,
            search: null,
            page: this.showList ? this.page : 1,
            first: this.showList ? 30 : 8
          },
          true,
          filterActivities,
          refetch ? 'network-only' : null
        )
        if (!this.showList) {
          this.activities = activities
        } else {
          const data = activities?.getAllActivities?.data
          this.activities = {
            getAllActivities: {
              data: (this.activities?.getAllActivities?.data ?? [])
                .concat(data)
                .reduce(
                  (unique, item) =>
                    unique.find((i) => i.uuid === item.uuid)
                      ? unique
                      : [...unique, item],
                  []
                ),
              paginatorInfo: activities?.getAllActivities?.paginatorInfo
            }
          }
          this.totalPages =
            activities?.getAllActivities?.paginatorInfo?.lastPage
          this.currentPage =
            activities?.getAllActivities?.paginatorInfo?.currentPage
        }
        this.customKey = setCustomKeyVariable()
      } catch (err) {
        this.$showError(err, this.t)
        this.$sentry(err, 'getActivities')
      } finally {
        this.$emit('calculateOffset')
        if (this.showLoading) {
          this.loadingDialog.close()
        }
        this.showResults = true
      }
    },
    async loadMoreItems() {
      if (
        this.page === this.currentPage &&
        this.currentPage < this.totalPages
      ) {
        this.page++
        this.getActivities(true)
      }
    },
    resetFilter() {
      this.activities = {
        getAllActivities: {
          data: [],
          paginatorInfo: {}
        }
      }
      this.filterActivities = {
        where: {
          uuid: {
            column: 'UUID',
            operator: 'NEQ',
            value: ''
          },
          kids_friendly: {
            column: 'KIDS_FRIENDLY',
            operator: 'EQ',
            value: ''
          },
          date: {
            column: 'DATE',
            operator: 'BETWEEN',
            value: {
              from: null,
              to: null
            }
          },
          dateFilter: '',
          difficulty_level: {
            column: 'DIFFICULTY_LEVEL',
            operator: 'EQ',
            value: ''
          },
          difficultyLevelLabel: '',
          duration: {
            column: 'DURATION',
            operator: '',
            value: 0
          }
        },
        filterField: {
          name: {
            value: ''
          },
          location: {
            value: ''
          },
          locations: {
            value: ''
          },
          orderForList: {
            value: ''
          },
          languages: {
            value: []
          },
          specialties: {
            value: []
          }
        }
      }
      this.currentPage = null
      this.page = 1
      this.filterExists = false
      this.getActivities(true)
    },
    filter() {
      this.activities = {
        getAllActivities: {
          data: [],
          paginatorInfo: {}
        }
      }
      this.currentPage = null
      this.page = 1
      this.filterDrawer = false
      this.filterExists = true
      this.getActivities()
    },
    getActivityDate(activity) {
      if (!activity.date) {
        return null
      }
      moment.locale(this.language)
      const date = moment(activity.date)
      return ` / ${date.format('DD MMMM, YYYY')}`
    },
    fullscreeMap() {
      this.$refs.activityMap.fullscreen()
    },
    rangeDateChange(value, field) {
      moment.locale('es')
      if (value && value[0]) {
        this.filterActivities.where[field].value.from = moment(value[0]).format(
          'YYYY-MM-DD'
        )
      }
      if (value && value[1]) {
        this.filterActivities.where[field].value.to = moment(value[1]).format(
          'YYYY-MM-DD'
        )
      }
      if (value && value[0] && value[1]) {
        this.filter()
      }
    },
    openFilterDrawer() {
      this.filterDrawer = true
      if (this.width >= 1100 && !this.activeNames.find((i) => i === '2')) {
        this.activeNames.push('2')
      }
    },
    isLanguageSelected(item) {
      return this.filterActivities.filterField.languages.value?.length
        ? this.filterActivities.filterField.languages.value.find(
            (i) => i === item.name.toLowerCase()
          )
          ? true
          : false
        : false
    },
    selectedLanguage(item) {
      const selected = this.isLanguageSelected(item)
      if (selected) {
        this.filterActivities.filterField.languages.value =
          this.filterActivities.filterField.languages.value.filter(
            (i) => i !== item.name.toLowerCase()
          )
      } else {
        this.filterActivities.filterField.languages.value.push(
          item.name.toLowerCase()
        )
      }
    },
    isSpecialtySelected(item) {
      return this.filterActivities.filterField.specialties.value?.length
        ? this.filterActivities.filterField.specialties.value.find(
            (i) => i === item.value
          )
          ? true
          : false
        : false
    },
    selectedSpecialty(item) {
      const selected = this.isSpecialtySelected(item)
      if (selected) {
        this.filterActivities.filterField.specialties.value =
          this.filterActivities.filterField.specialties.value.filter(
            (i) => i !== item.value
          )
      } else {
        this.filterActivities.filterField.specialties.value.push(item.value)
      }
    },
    isDurationSelected(item) {
      return JSON.stringify(this.filterActivities.where.duration.value) ===
        JSON.stringify(item.value)
        ? true
        : false
    },
    selectedDuration(item) {
      const selected = this.isDurationSelected(item)
      if (selected) {
        this.filterActivities.where.duration.value = ''
        this.filterActivities.where.duration.operator = ''
      } else {
        this.filterActivities.where.duration.value = item.value
        this.filterActivities.where.duration.operator = item.operator
      }
    },
    isDisableDates(date) {
      if (date) {
        moment.locale('en')
        let dayRaw = moment(date)
        let today = moment()
        if (dayRaw.isBefore(today, 'day')) {
          return true
        }
        return false
      }
    }
  }
})
</script>

<style scoped lang="scss">
.activities-container:not(.list) {
  @media (min-width: 1100px) {
    padding: 40px 0 60px 0;
  }
  @media (max-width: 1100px) {
    padding: 40px 0 60px 0;
  }
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: left;
  background-color: var(--brand-off-white);
  .activities-title {
    width: 100%;
    text-align: left;
    margin-bottom: 24px;
    display: block;
    position: relative;
    @media (min-width: 1100px) {
      padding-left: 96px;
      padding-right: 96px;
    }
    @media (max-width: 1100px) {
      padding-left: 24px;
      padding-right: 24px;
    }
    .title-text {
      display: inline-block;
      .heading3 {
        color: var(--brand-off-black);
      }
    }
    .title-action {
      float: right;
      display: inline-block;
      position: relative;
      top: 6px;
      i {
        margin-left: 4px;
      }
    }
  }
  .activities-gallery {
    overflow-x: hidden;
    white-space: nowrap;
    text-align: left;
    width: 100%;
    max-width: 100vw;
    .gallery-container {
      @media (min-width: 1100px) {
        padding-left: 96px;
        padding-right: 96px;
      }
      @media (max-width: 1100px) {
        padding-left: 24px;
        padding-right: 24px;
      }
      .carousel__slide {
        @media (min-width: 1100px) {
          height: 374px;
        }
        @media (max-width: 1100px) {
          height: 325px;
        }
        align-items: flex-start;
        padding-right: 16px;
      }
      .gallery {
        cursor: pointer;
        @media (min-width: 1100px) {
          height: 374px;
        }
        @media (max-width: 1100px) {
          height: 325px;
        }
        width: 100%;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        .image {
          @media (min-width: 1100px) {
            height: 288px;
          }
          @media (max-width: 1100px) {
            height: 241px;
          }
          .exclusive {
            display: flex;
            height: 32px;
            padding: 8px 12px;
            position: absolute;
            right: 24px;
            top: 8px;
            border-radius: 16px;
            background: var(--tins-light-2);
          }
          &.with-image {
            img,
            video {
              object-fit: cover;
              border-radius: 3px;
              width: 100%;
              height: 100%;
            }
          }
          &:not(.with-image) {
            @media (min-width: 1100px) {
              height: 288px;
            }
            @media (max-width: 1100px) {
              height: 241px;
            }
            background-color: var(--action-hover);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 3px;
            img {
              height: 120px;
              width: 171px;
            }
          }
        }
        .gallery-title {
          margin-top: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .heading6 {
            color: var(--brand-off-black);
          }
        }
        .gallery-location {
          margin-top: 8px;
          height: 16px;
        }
        .gallery-price {
          margin-top: 4px;
          height: 16px;
        }
      }
    }
  }
}

.activities-container.list {
  padding: 0 0 0 0;
  background-color: var(--brand-white);
  .activities-filter {
    background-color: var(--brand-off-white);
    margin-top: -20px;
    padding-bottom: 24px;
    position: relative;
    @media (min-width: 1100px) {
      padding-left: 96px;
      padding-right: 96px;
    }
    @media (max-width: 1100px) {
      padding-left: 24px;
      padding-right: 24px;
    }
    &.open {
      padding-bottom: 360px !important;
    }
    .filter-group {
      @media (min-width: 1100px) {
      }
      @media (max-width: 1100px) {
        display: flex;
        flex-wrap: wrap;
      }
      .item {
        @media (min-width: 1100px) {
          display: inline-block;
          &:not(:last-of-type) {
            margin-right: 6px;
          }
        }
        @media (max-width: 1100px) {
          flex: 0 0 25%;
          margin: 0 8px 8px 0;
        }
        .el-dropdown {
          .selector-container {
            .el-button {
              i {
                display: inline-block;
                &:nth-of-type(1) {
                  margin-right: 8px;
                }
                &:nth-of-type(2) {
                  margin-left: 8px;
                  margin-right: -4px;
                }
              }
              .button-text {
                max-width: 250px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                .body2 {
                  color: var(--brand-off-black);
                  display: inline-block;
                  margin-right: 8px;
                }
              }
            }
          }
          :deep(.filter-dropdown) {
            width: 288px;
            background-color: var(--brand-off-white);
            border: 1px solid transparent !important;
            box-shadow: 0 0 0 0 !important;
            .el-scrollbar {
              .el-dropdown__list {
                .el-dropdown-menu {
                  padding: 16px;
                  background-color: var(--brand-off-white);
                  .el-dropdown-menu__item {
                    padding-left: 0 !important;
                    padding-right: 0 !important;
                    &:hover,
                    &:focus {
                      background-color: transparent !important;
                    }
                    &:not(:last-of-type) {
                      margin-bottom: 16px;
                    }
                    .el-checkbox {
                      margin-right: 8px;
                    }
                    .body2 {
                      color: var(--brand-off-black);
                    }

                    .first-block {
                      width: calc(40% - 2px);
                      margin-right: 2px;
                      white-space: normal;
                      span {
                        display: block;
                        &:nth-of-type(1) {
                          color: var(--brand-off-black);
                        }
                        &:nth-of-type(2) {
                          color: var(--brand-off-black);
                        }
                      }
                    }
                    .second-block {
                      text-align: right;
                      width: calc(50% - 2px);
                    }

                    &.actions {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    }
                  }
                }
              }
            }
            .el-popper__arrow {
              display: none;
            }
            &.location {
              width: 442px !important;
              padding: 8px 24px 32px 24px;
            }
            &.accommodation-type {
              width: 511px !important;
              padding: 16px 24px 32px 24px;
            }
          }
        }
        :deep(.landing-date-range) {
          position: relative;
          top: 34px;
          margin-top: -34px;
          width: 400px !important;
        }
      }
    }
    .button-filter {
      i {
        margin-left: 8px;
        margin-right: -4px;
      }
      @media (min-width: 1100px) {
        position: absolute;
        right: 96px;
        top: 0;
      }
    }
  }
  .activities-title {
    width: 100%;
    text-align: left;
    margin-bottom: 24px;
    display: block;
    position: relative;
    padding-top: 40px;
    @media (min-width: 1100px) {
      padding-left: 96px;
      padding-right: 96px;
    }
    @media (max-width: 1100px) {
      padding-left: 24px;
      padding-right: 24px;
    }
    .title-text {
      display: inline-block;
      .el-button {
        margin-right: 16px;
        position: relative;
        top: -8px;
      }
      .heading3 {
        color: var(--brand-off-black);
      }
    }
    .title-action {
      float: right;
      display: inline-block;
      position: relative;
      top: 6px;
      i {
        margin-left: 4px;
      }
    }
    .title-filter {
      @media (min-width: 700px) {
        float: right;
        display: inline-block;
        position: relative;
        top: 6px;
        .el-button {
          &:first-of-type {
            margin-right: 8px;
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: flex-start;
            i {
              margin-left: 8px;
              margin-right: 0 !important;
            }
          }
        }
        .el-select {
          width: 200px !important;
          display: inline-block;
        }
      }
      @media (max-width: 700px) {
        display: inline-block;
        float: right;
        .el-button {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 0 !important;
        }
      }
    }
  }
  .activities-gallery {
    @media (min-width: 1100px) {
      padding-bottom: 60px;
    }
    @media (max-width: 1100px) {
      padding-bottom: 60px;
    }
    .gallery-container {
      @media (min-width: 1100px) {
        padding-left: 96px;
        padding-right: 96px;
      }
      @media (max-width: 1100px) {
        padding-left: 24px;
        padding-right: 24px;
      }
      .gallery {
        cursor: pointer;
        @media (min-width: 1100px) {
          height: 520px;
        }
        @media (max-width: 1100px) {
          height: 345px;
        }
        .image {
          background-size: cover !important;
          background-repeat: no-repeat;
          width: 100%;
          @media (min-width: 1100px) {
            height: 395px;
          }
          @media (max-width: 1100px) {
            height: 241px;
          }
          position: relative;
          .exclusive {
            display: flex;
            height: 32px;
            padding: 8px 12px;
            position: absolute;
            right: 16px;
            top: 8px;
            border-radius: 16px;
            background: var(--tins-light-2);
          }
          &.with-image {
            img,
            video {
              object-fit: cover;
              border-radius: 3px;
              width: 100%;
              height: 100%;
            }
          }
          &:not(.with-image) {
            @media (min-width: 1100px) {
              height: 395px;
            }
            @media (max-width: 1100px) {
              height: 241px;
            }
            background-color: var(--action-hover);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 3px;
            img {
              height: 120px;
              width: 171px;
            }
          }
        }
        .gallery-title {
          margin-top: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .heading6 {
            color: var(--brand-off-black);
          }
        }
        .gallery-location {
          margin-top: 8px;
          height: 16px;
        }
        .gallery-price {
          margin-top: 4px;
          height: 16px;
        }
        .gallery-actions {
          margin-top: 4px;
        }
      }
    }
  }
}

:deep(.el-overlay) {
  .left-drawer {
    .el-drawer__body {
      .form-name {
        padding: 24px 0 24px 0;
      }
      .el-collapse {
        margin-top: 32px;
        margin-bottom: 32px;
        border: 0 !important;
        .el-collapse-item {
          border: 0 !important;
          .el-collapse-item__header {
            background-color: var(--brand-off-white) !important;
            border: 0 !important;
            position: relative;
            i.el-icon {
              svg {
                display: none;
              }
            }
            i.filter-icon {
              position: absolute;
              right: 0 !important;
            }
          }
          .el-collapse-item__wrap {
            border-bottom: 1px solid var(--brand-white) !important;
            .el-collapse-item__content {
              background-color: var(--brand-off-white) !important;
              .item-list {
                max-height: 300px;
                padding-top: 6px;
                padding-bottom: 10px;
                overflow-y: auto;
                .item {
                  &:not(:last-of-type) {
                    margin-bottom: 8px;
                  }
                  .body2 {
                    position: relative;
                    top: -14px;
                    margin-left: 8px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>